import { CmsRegistrationRoot } from '../cms/cms-registration-root.interface';
import { CmsRegistrationConfirmationPageHeader } from './cms-registration-confirmation-page.interface';

export type CmsRegistrationConfirmationPage = CmsRegistrationRoot &
  CmsRegistrationConfirmationPageHeader;
